export const articles = [
  {
    id: "a1",
    slug: "first-job-interview-complete-guide",
    title: "第一次面试完全攻略：从简历到Offer的全流程指南",
    category: "career",
    excerpt: "收到面试通知那一刻，心跳加速、手心冒汗——别担心，这是每个人的必经之路。本文为你拆解面试前中后的每一个关键步骤，从着装选择到薪资谈判，让你从容应对人生的第一场面试。",
    content: `
      <h2>面试前：充分的准备是自信的基石</h2>
      <p>人生的第一次面试，往往伴随着紧张、不安和自我怀疑。但请记住：适度的紧张是正常的生理反应，它说明你重视这次机会。关键在于，如何将这份紧张转化为积极的准备动力。</p>
      
      <h3>一、深入了解目标公司</h3>
      <p>在面试前，花至少3-5小时研究这家公司。浏览官网，了解他们的产品、文化、近期新闻。关注公司的社交媒体账号，看看他们最近在讨论什么话题。如果你能在面试中自然地提及公司近期的一项成就或动态，面试官会对你留下深刻印象。</p>
      <p>同时，仔细阅读职位描述（JD），把每一条要求拆解开来，思考自己有哪些经历和能力可以对应。准备2-3个具体的案例，用STAR法则（情境-任务-行动-结果）来组织你的回答。</p>
      
      <h3>二、准备常见面试问题</h3>
      <p>第一次面试虽然是新体验，但面试问题大多有迹可循。以下是几个高频问题，建议提前准备并多次练习：</p>
      <ul>
        <li><strong>「请做一个简单的自我介绍」</strong>——控制在2分钟以内，突出与岗位相关的经历和技能，避免流水账式地复述简历。</li>
        <li><strong>「你为什么想加入我们公司？」</strong>——结合你对公司的研究和自身的职业规划来回答，展现诚意和思考深度。</li>
        <li><strong>「你最大的缺点是什么？」</strong>——选择一个真实的、正在改进的缺点，并说明你为此采取了哪些行动。避免说「我太追求完美」这类套路式回答。</li>
        <li><strong>「你有什么问题想问我们吗？」</strong>——这几乎是每场面试的必答题。提前准备3-5个有深度的问题，比如团队架构、培训体系、岗位发展路径等。</li>
      </ul>
      
      <h3>三、着装与形象管理</h3>
      <p>第一印象在面试中至关重要。着装原则是：比该公司的日常着装正式一个级别。如果不确定，宁可稍微正式一些。衣服要提前一天熨烫平整，鞋子擦拭干净。这些细节体现的是你对这次机会的重视程度。</p>
      
      <h2>面试中：展现最好的自己</h2>
      <p>当面试真正开始的那一刻，紧张感可能达到顶峰。深呼吸，给自己一个心理暗示：「我已经准备充分，现在只需要展现真实的自己。」</p>
      
      <h3>四、面试礼仪细节</h3>
      <p>提前10-15分钟到达面试地点，不要太早也不要迟到。进入面试室时主动问好，微笑并保持眼神交流。坐姿要端正但不僵硬，双手自然放在桌面上或膝盖上。这些小细节会在潜意识中影响面试官对你的评价。</p>
      
      <h3>五、回答问题的核心技巧</h3>
      <p>面试中最重要的是「真诚」和「结构化」。不要试图编造你没有的经历——有经验的面试官一眼就能识破。对于不确定的问题，可以说「这个问题我需要思考一下」，给自己几秒钟的组织时间，这比仓促说一个不相关的答案要好得多。</p>
      
      <h2>面试后：把握最后的机会</h2>
      <p>面试结束不意味着一切尘埃落定。在24小时内发送一封感谢邮件，简要重申你对职位的兴趣，并提及面试中讨论的一两个要点。这不仅是礼貌，更是展现你职业素养的最后机会。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-10",
    readTime: "8分钟",
    imageSeq: "interview-guide-01",
    imageQuery: "A warm minimalist workspace scene with a confident young professional preparing for an interview, soft natural lighting, calm and encouraging atmosphere, editorial style with cream and warm beige tones, clean organized desk with notebook and pen, modern professional setting with gentle shadows",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20workspace%20scene%20with%20a%20confident%20young%20professional%20preparing%20for%20an%20interview%2C%20soft%20natural%20lighting%2C%20calm%20and%20encouraging%20atmosphere%2C%20editorial%20style%20with%20cream%20and%20warm%20beige%20tones%2C%20clean%20organized%20desk%20with%20notebook%20and%20pen%2C%20modern%20professional%20setting%20with%20gentle%20shadows&width=800&height=480&seq=interview-guide-01&orientation=landscape",
    tags: ["面试技巧", "求职攻略", "职场新人", "职业规划"],
  },
  {
    id: "a2",
    slug: "first-date-psychological-preparation",
    title: "第一次约会心理建设：从紧张到享受的心路历程",
    category: "relationship",
    excerpt: "第一次约会前夜辗转难眠？脑海中预演了无数种可能的尴尬场景？深呼吸，你不是一个人在战斗。这篇文章将带你走过约会心理建设的完整路径，让你从紧张纠结到享受当下。",
    content: `
      <h2>约会前：正视你的紧张情绪</h2>
      <p>第一次约会的紧张感，本质上来自于对未知的恐惧和对自我表现的高期待。心理学研究表明，适度的焦虑实际上能提升社交表现——它会让你更加专注和敏锐。所以，别急着否定自己的紧张情绪，先接纳它。</p>
      
      <h3>一、降低期待，聚焦当下</h3>
      <p>很多人第一次约会的压力来源于过高的期待——「我们要找到真爱」「这次约会必须完美」。试着把心态调整为：「这是一次认识新朋友的机会，结果顺其自然。」当你把目标从「必须成功」降级为「享受过程」，紧张感会自然减轻大半。</p>
      
      <h3>二、选择熟悉的约会地点</h3>
      <p>第一次约会建议选择你比较熟悉的环境。熟悉的场所会给你安全感，让你更容易放松。咖啡馆、安静的公园、有趣的手作工坊都是不错的选择。避免过于嘈杂的酒吧或需要长时间对视的正式餐厅——这些环境往往会放大紧张感。</p>
      
      <h3>三、准备一些话题储备</h3>
      <p>没有人希望在约会中陷入尴尬的沉默。提前准备5-8个开放性话题，比如最近看的一部电影、去过的有趣地方、对方资料中让你好奇的点。记住，好的对话是「提问-倾听-回应」的循环，而不是单方面的陈述。</p>
      
      <h2>约会中：做真实的自己</h2>
      <p>当你坐到了对方面前，记住一个简单的原则：真诚永远比完美更有吸引力。刻意打造的人设不仅难以维持，还会让你自己感到疲惫。展现真实的自己，对方喜欢的才是真正的你。</p>
      
      <h2>约会后：给自己一个温柔的复盘</h2>
      <p>无论约会结果如何，都值得给自己一个肯定——你勇敢地迈出了第一步。不要过度分析对方的每一个表情和每一句话，那会陷入无意义的内耗。睡一觉，第二天再以轻松的心态决定下一步。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-09",
    readTime: "7分钟",
    imageSeq: "date-guide-02",
    imageQuery: "A warm cozy coffee shop interior with soft ambient lighting, two people having a relaxed conversation across a wooden table, gentle afternoon sunlight streaming through windows, comforting and intimate atmosphere, editorial photography with warm terracotta and cream tones, blurred background with plants and bookshelves",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20cozy%20coffee%20shop%20interior%20with%20soft%20ambient%20lighting%2C%20two%20people%20having%20a%20relaxed%20conversation%20across%20a%20wooden%20table%2C%20gentle%20afternoon%20sunlight%20streaming%20through%20windows%2C%20comforting%20and%20intimate%20atmosphere%2C%20editorial%20photography%20with%20warm%20terracotta%20and%20cream%20tones%2C%20blurred%20background%20with%20plants%20and%20bookshelves&width=800&height=480&seq=date-guide-02&orientation=landscape",
    tags: ["约会指南", "心理建设", "人际交往", "情感成长"],
  },
  {
    id: "a3",
    slug: "first-public-speaking-overcome-fear",
    title: "第一次公开演讲：克服舞台恐惧的七个实战技巧",
    category: "study",
    excerpt: "站在台上，聚光灯打在身上，台下几十双眼睛注视着你——光是想象这个场景就让人手心冒汗。公开演讲恐惧是世界上最常见的恐惧之一，但它完全可以被克服。",
    content: `
      <h2>为什么我们会害怕公开演讲？</h2>
      <p>从进化心理学角度看，被众多目光注视在远古时期意味着被群体排斥的危险。这种恐惧深植于我们的基因中。但好消息是：现代社会中，公开演讲是可以通过系统训练来掌握的一项技能，而非天赋。</p>
      
      <h3>一、充分准备是恐惧的解药</h3>
      <p>80%的演讲恐惧来源于准备不足。当你对自己的内容有绝对的信心时，紧张感会自动下降。建议将演讲稿至少完整演练5遍以上，其中至少2遍是在模拟真实环境中进行的——站在房间中央，对着镜子或录下自己的表现来回看。</p>
      
      <h3>二、掌握「3-3-3」呼吸法</h3>
      <p>在上台前3分钟，进行「3-3-3」呼吸练习：吸气3秒，屏息3秒，呼气3秒。重复5-8次。这个简单的呼吸技巧能有效降低心率，平复紧张情绪。</p>
      
      <h3>三、善用「力量姿势」</h3>
      <p>社会心理学家Amy Cuddy的研究表明，在上台前保持2分钟的「高能量姿势」（如双手叉腰、展开肩膀站立），能显著提升自信激素水平。在上台前找一个安静的角落，做2分钟的力量姿势，你会发现状态立刻不同。</p>
      
      <h3>四、把注意力从自己转移到观众</h3>
      <p>紧张的核心在于过度关注自己——「我看起来怎么样？」「我说错了吗？」试着把注意力转向观众：「我今天来是为了给他们带来价值。」这个简单的心理转换能大幅缓解紧张。</p>
      
      <h3>五、接受「不完美」</h3>
      <p>即使是最顶级的演讲者也会出现小失误。关键是：除了你自己，几乎没有人会注意到那些小瑕疵。停顿一下、喝口水、微笑继续——观众不会因此降低对你的评价，反而会觉得你更加真实。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-08",
    readTime: "6分钟",
    imageSeq: "speaking-guide-03",
    imageQuery: "A modern minimalist stage setting with warm focused spotlight, microphone on stand, elegant auditorium background in soft focus, warm amber and cream color palette, inspirational and professional atmosphere, editorial photography style with clean composition and gentle shadows",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20stage%20setting%20with%20warm%20focused%20spotlight%2C%20microphone%20on%20stand%2C%20elegant%20auditorium%20background%20in%20soft%20focus%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20inspirational%20and%20professional%20atmosphere%2C%20editorial%20photography%20style%20with%20clean%20composition%20and%20gentle%20shadows&width=800&height=480&seq=speaking-guide-03&orientation=landscape",
    tags: ["公开演讲", "克服恐惧", "沟通技巧", "自我提升"],
  },
  {
    id: "a4",
    slug: "first-time-living-alone-preparation-checklist",
    title: "第一次独立租房生活：从看房到入住的完整清单",
    category: "life",
    excerpt: "要开始一个人的生活了，兴奋中带着一丝不安？独立租房是成年人的成人礼，这份从看房、签合同到搬家入住的完整清单，帮你绕过所有新手容易踩的坑。",
    content: `
      <h2>找房阶段：谨慎是最大的智慧</h2>
      <p>第一次独立租房，既是对自由的向往，也是生活能力的全面考验。一个好的开始，能让你少走很多弯路。</p>
      
      <h3>一、明确预算和需求</h3>
      <p>租金支出建议控制在月收入的30%以内。除了租金，还要考虑：水电燃气费、物业费、网费、通勤交通费。做一个全面的月度支出预估，避免入住后才发现预算超支。</p>
      
      <h3>二、实地看房的检查清单</h3>
      <p>看房时带上这份检查清单，逐一确认：水压是否正常、热水器工作情况、空调制冷制热效果、门窗是否密封、墙面是否有渗水痕迹、插座位置和数量、手机信号和网络覆盖。白天和晚上各看一次，了解不同时段的噪音和采光情况。</p>
      
      <h2>签合同：保护自己的权益</h2>
      <p>签合同前仔细阅读每一条款。特别注意：租期、押金金额及退还条件、维修责任划分、是否能转租、违约金条款。如有不明白的地方，大胆提问——这是你的合法权益。</p>
      
      <h2>入住后：打造属于自己的小窝</h2>
      <p>入住后的第一个周末，花时间把房间彻底清洁一遍。根据自己的喜好布置空间，哪怕只是添置一盆绿植、一幅喜欢的画，都能让这个空间开始有「家」的感觉。独立生活的第一步，就是学会好好照顾自己。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-07",
    readTime: "10分钟",
    imageSeq: "living-alone-04",
    imageQuery: "A bright sunlit modern apartment interior with minimal furniture, warm natural light streaming through large windows, cozy clean bedroom with soft bedding and a potted plant, cream and warm beige color palette, editorial home photography with serene and hopeful atmosphere, organized and peaceful living space",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20bright%20sunlit%20modern%20apartment%20interior%20with%20minimal%20furniture%2C%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20cozy%20clean%20bedroom%20with%20soft%20bedding%20and%20a%20potted%20plant%2C%20cream%20and%20warm%20beige%20color%20palette%2C%20editorial%20home%20photography%20with%20serene%20and%20hopeful%20atmosphere%2C%20organized%20and%20peaceful%20living%20space&width=800&height=480&seq=living-alone-04&orientation=landscape",
    tags: ["独立生活", "租房攻略", "生活技能", "成人礼"],
  },
  {
    id: "a5",
    slug: "first-social-party-icebreaker-tips",
    title: "第一次参加社交派对：破冰与融入的实用策略",
    category: "social",
    excerpt: "推开那扇门的瞬间，满屋子都是陌生人，你站在门口不知道该往哪走——这样的场景是不是让你望而却步？社交场合的第一次总是最难的，但也是最值得突破的。",
    content: `
      <h2>入场前：调整心态是关键</h2>
      <p>社交焦虑的核心信念往往是「所有人都在看着我、评判我」。事实上，心理学中的「聚光灯效应」告诉我们：人们远没有你想象的那么关注你。每个人都在关注自己，而不是你。认识到这一点，你会轻松很多。</p>
      
      <h3>一、提前了解活动信息</h3>
      <p>了解活动的主题、参与者的大致背景、场地布局。这些信息会成为你开启对话的素材。如果活动有线上社群，提前加入并在群里简单打个招呼，这样到场时至少有几个「脸熟」的人。</p>
      
      <h3>二、掌握「三人原则」</h3>
      <p>到场后，给自己定一个小目标：至少和三个不同的人进行超过3分钟的对话。这个具体的目标能帮你克服最初的社交惰性。一旦完成「三人指标」，你往往会发现社交并没有想象中那么可怕。</p>
      
      <h3>三、破冰话题库</h3>
      <p>准备几个通用破冰问题：你也是第一次参加这个活动吗？/ 今天的主题让我想起.../ 你是怎么知道这个活动的？记住，提问之后认真倾听，并从对方的回答中找到延伸话题的线索。</p>
      
      <h3>四、学会优雅地「转场」</h3>
      <p>当你和一个聊得差不多的时候，可以用「很高兴认识你，我去拿杯饮料，回头再聊」或者「我看到那边有个朋友，先失陪一下」来自然地结束对话。这比突然陷入沉默要礼貌得多。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-06",
    readTime: "5分钟",
    imageSeq: "social-party-05",
    imageQuery: "A warm elegant evening social gathering with soft amber lighting, people mingling casually in small groups, modern loft space with exposed brick and warm string lights, relaxed sophisticated atmosphere, editorial event photography with cream and terracotta tones, blurred background showing lively conversations",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20elegant%20evening%20social%20gathering%20with%20soft%20amber%20lighting%2C%20people%20mingling%20casually%20in%20small%20groups%2C%20modern%20loft%20space%20with%20exposed%20brick%20and%20warm%20string%20lights%2C%20relaxed%20sophisticated%20atmosphere%2C%20editorial%20event%20photography%20with%20cream%20and%20terracotta%20tones%2C%20blurred%20background%20showing%20lively%20conversations&width=800&height=480&seq=social-party-05&orientation=landscape",
    tags: ["社交技巧", "破冰策略", "人际沟通", "自我突破"],
  },
  {
    id: "a6",
    slug: "first-solo-travel-complete-handbook",
    title: "第一次独自旅行：从行前焦虑到旅途享受的蜕变手册",
    category: "travel",
    excerpt: "一个人拖着行李箱站在机场的那一刻，既自由又忐忑。独自旅行的第一次，是你送给自己最好的成长礼物。这份手册涵盖安全、预算、行程规划等方方面面。",
    content: `
      <h2>为什么你应该尝试独自旅行？</h2>
      <p>独自旅行是认识自己最直接的方式。没有同伴的依赖，你必须自己做每一个决定，解决每一个问题。这个过程会让你发现自己的潜能远超想象。</p>
      
      <h3>一、行前安全准备</h3>
      <p>第一次独自旅行，安全是首要考虑。提前查阅目的地的安全指数和中国使领馆信息。购买一份旅行保险，把行程分享给至少一位家人或朋友。下载离线地图，保存紧急联系电话。这些准备工作不会花太多时间，但能让你在旅途中更加安心。</p>
      
      <h3>二、行李打包哲学</h3>
      <p>独自旅行时，行李越轻越好。一个登机箱加一个双肩包是最理想的配置。记住「1+1法则」：每种类型的衣物带1件穿1件就够了。你不需要为「万一」准备太多——除非是去偏远地区，城市里什么都能买到。</p>
      
      <h3>三、享受独处的旅行时光</h3>
      <p>一个人吃饭、一个人逛博物馆、一个人看日落——这些都是独自旅行中最珍贵的体验。你不需要迎合任何人的节奏，可以随心所欲地改变计划。用一本旅行手账记录每天的所见所想，多年后翻看，你会发现那是青春里最自由的一章。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-05",
    readTime: "9分钟",
    imageSeq: "solo-travel-06",
    imageQuery: "A serene travel scene with a solo traveler looking out over a beautiful landscape at golden hour, warm sunset lighting, rolling hills or coastal view in the distance, peaceful and liberating atmosphere, editorial travel photography with warm amber and soft earth tones, backpack silhouette against the glowing sky, poetic composition",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20serene%20travel%20scene%20with%20a%20solo%20traveler%20looking%20out%20over%20a%20beautiful%20landscape%20at%20golden%20hour%2C%20warm%20sunset%20lighting%2C%20rolling%20hills%20or%20coastal%20view%20in%20the%20distance%2C%20peaceful%20and%20liberating%20atmosphere%2C%20editorial%20travel%20photography%20with%20warm%20amber%20and%20soft%20earth%20tones%2C%20backpack%20silhouette%20against%20the%20glowing%20sky%2C%20poetic%20composition&width=800&height=480&seq=solo-travel-06&orientation=landscape",
    tags: ["独自旅行", "旅行攻略", "安全出行", "自我发现"],
  },
  {
    id: "a7",
    slug: "first-work-report-newcomer-guide",
    title: "第一次工作汇报：新人的职场亮相必修课",
    category: "career",
    excerpt: "入职第一个月，主管说：「下周你来给大家做个项目汇报。」你的心跳瞬间加速。第一次在职场正式亮相，如何展现专业与自信？",
    content: `
      <h2>工作汇报不是表演，而是沟通</h2>
      <p>很多新人把工作汇报理解成一场「考试」——等待被评判、被打分。实际上，工作汇报的本质是信息同步和资源获取。你的目标不是「不出错」，而是让你的上级和同事清楚地了解你的工作进展、遇到的问题以及需要的支持。</p>
      
      <h3>一、结构化你的汇报内容</h3>
      <p>一个好的汇报遵循「结论先行」原则。开门见山地给出核心结论，然后按照「已完成-进行中-待推进」的逻辑展开。每个部分控制3-5个要点，避免信息过载。</p>
      
      <h3>二、用数据和事实说话</h3>
      <p>新人最常犯的错误是使用模糊描述：「项目进展顺利」「反响还不错」。用具体的数据替换模糊词汇：「项目进度完成75%，比计划提前2天」「用户满意度从82%提升到89%」。数据让汇报更有说服力。</p>
      
      <h3>三、预演和试讲</h3>
      <p>在自己的工位前完整预演至少两遍，计时并调整语速。如果可能，请一位信任的同事旁听并给反馈。预演时特别注意：是否有逻辑跳跃？时间是否控制得当？PPT是否有拼写错误？</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-04",
    readTime: "6分钟",
    imageSeq: "work-report-07",
    imageQuery: "A modern bright conference room with a young professional presenting at a whiteboard, warm natural light, clean minimalist office interior, professional yet approachable atmosphere, editorial corporate photography with cream and warm gray tones, confident posture and focused expression",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20modern%20bright%20conference%20room%20with%20a%20young%20professional%20presenting%20at%20a%20whiteboard%2C%20warm%20natural%20light%2C%20clean%20minimalist%20office%20interior%2C%20professional%20yet%20approachable%20atmosphere%2C%20editorial%20corporate%20photography%20with%20cream%20and%20warm%20gray%20tones%2C%20confident%20posture%20and%20focused%20expression&width=800&height=480&seq=work-report-07&orientation=landscape",
    tags: ["工作汇报", "职场新人", "沟通技巧", "职业发展"],
  },
  {
    id: "a8",
    slug: "first-meeting-parents-in-law-preparation",
    title: "第一次见对方父母：从紧张到被接纳的暖心指南",
    category: "relationship",
    excerpt: "TA说：「这周末，我爸妈想见见你。」一句话让你的世界瞬间安静。第一次见对方父母，是感情中的里程碑事件。这份指南帮你从容应对，留下美好的第一印象。",
    content: `
      <h2>见面之前：信息是最好的武器</h2>
      <p>向你的另一半了解清楚：父母的性格特点、兴趣爱好、家庭习惯。有没有什么需要避免的话题？家里有没有什么特别的规矩？准备一束鲜花或一份得体的伴手礼，不需要贵重，体现心意最重要。</p>
      
      <h3>一、着装：得体大于时尚</h3>
      <p>第一次见父母，着装原则是「尊重对方的审美期待」。询问你的另一半：父母比较传统还是开放？是偏向正式还是休闲？不确定时，选择简约大方的风格，避免过于前卫或随意的打扮。</p>
      
      <h3>二、聊天艺术：多听少说</h3>
      <p>见面时，保持真诚的微笑和适当的眼神交流。主动聊一些安全的话题：父母的身体健康、家里的布置、感兴趣的美食。让父母多说，你认真倾听并给予积极的回应。这是展现你修养和情商的最佳方式。</p>
      
      <h3>三、帮忙收拾：行动胜过言语</h3>
      <p>饭后主动提出帮忙收拾碗筷。即使被客气地拒绝，这个动作本身已经传递了你的教养和体贴。小小的行动，往往比华丽的言辞更能打动人心。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-03",
    readTime: "7分钟",
    imageSeq: "meeting-parents-08",
    imageQuery: "A warm cozy Chinese family living room with soft afternoon light, elegant and comfortable home setting, welcoming atmosphere with fresh flowers on the coffee table, cream and warm wood tones, lifestyle photography with gentle and intimate mood, teapot and cups suggesting a family gathering",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20cozy%20Chinese%20family%20living%20room%20with%20soft%20afternoon%20light%2C%20elegant%20and%20comfortable%20home%20setting%2C%20welcoming%20atmosphere%20with%20fresh%20flowers%20on%20the%20coffee%20table%2C%20cream%20and%20warm%20wood%20tones%2C%20lifestyle%20photography%20with%20gentle%20and%20intimate%20mood%2C%20teapot%20and%20cups%20suggesting%20a%20family%20gathering&width=800&height=480&seq=meeting-parents-08&orientation=landscape",
    tags: ["见家长", "情感关系", "家庭礼仪", "人际沟通"],
  },
  {
    id: "a9",
    slug: "first-time-cooking-beginners-cuisine",
    title: "第一次下厨：零基础新手也能成功的十道入门菜",
    category: "life",
    excerpt: "看着厨房里的锅碗瓢盆，不知从何下手？第一次下厨不需要米其林大厨的技法，只需要正确的入门方法。从煮一碗完美的米饭开始，你会爱上自己动手的感觉。",
    content: `
      <h2>走进厨房的第一步：工具比食材更重要</h2>
      <p>第一次下厨的新手，最需要的不是复杂的食谱，而是一套基本的工具和正确的安全知识。一把好用的菜刀、一个不粘锅、一个可计时的电饭煲，你的厨房起步装备就齐了。</p>
      
      <h3>一、从「煮」和「炒」开始</h3>
      <p>炖、蒸、烤、煎、炸——烹饪技法有十几种，但作为新手，你只需要先掌握「煮」和「炒」。「煮」可以完成一锅有菜有肉的营养汤面，「炒」能让你做出色香味俱全的家常菜。两个技能，足以让你在厨房中建立最初的自信。</p>
      
      <h3>二、推荐新手十道入门菜</h3>
      <p>番茄炒蛋、青椒肉丝、蛋炒饭、白灼青菜、红烧鸡翅、蒸水蛋、土豆炖牛肉、紫菜蛋花汤、拍黄瓜、煮泡面升级版。每一道菜都经过精心挑选——食材易得、步骤简单、容错率高、味道有保证。</p>
      
      <h3>三、厨房安全第一条</h3>
      <p>热油遇水会飞溅，切菜时手指要内扣，开火前确认锅底是干的。这些看似简单的小常识，是每个新手都必须牢记的安全准则。安全第一，美味第二。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-02",
    readTime: "8分钟",
    imageSeq: "first-cooking-09",
    imageQuery: "A bright clean modern kitchen with warm morning light, fresh ingredients on a wooden cutting board including tomatoes, eggs, and green onions, homely and inviting atmosphere, food photography with cream and warm tones, steam rising from a cooking pot, beginner-friendly cooking scene with simple tools",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20bright%20clean%20modern%20kitchen%20with%20warm%20morning%20light%2C%20fresh%20ingredients%20on%20a%20wooden%20cutting%20board%20including%20tomatoes%2C%20eggs%2C%20and%20green%20onions%2C%20homely%20and%20inviting%20atmosphere%2C%20food%20photography%20with%20cream%20and%20warm%20tones%2C%20steam%20rising%20from%20a%20cooking%20pot%2C%20beginner-friendly%20cooking%20scene%20with%20simple%20tools&width=800&height=480&seq=first-cooking-09&orientation=landscape",
    tags: ["下厨入门", "烹饪技巧", "生活技能", "美食制作"],
  },
  {
    id: "a10",
    slug: "first-exam-anxiety-management",
    title: "第一次重要考试：考前焦虑管理的科学方法",
    category: "study",
    excerpt: "考试前一周开始失眠，走进考场时大脑一片空白——考试焦虑是学习路上最大的绊脚石。这篇文章从认知科学角度告诉你：焦虑并不可怕，可怕的是不知道如何与焦虑共处。",
    content: `
      <h2>考试焦虑的真相</h2>
      <p>耶克斯-多德森定律告诉我们：适度的焦虑能提升表现水平，过高或过低都会影响发挥。所以，目标不是「消除焦虑」，而是将焦虑调整到「刚刚好」的水平。</p>
      
      <h3>一、制定科学的复习计划</h3>
      <p>焦虑最大的来源是不确定性。一个具体到每一天、每一个小时的复习计划，能有效减少不确定感。使用「番茄工作法」——专注25分钟，休息5分钟——来提高复习效率。计划中一定要留出缓冲时间，不要排得太满。</p>
      
      <h3>二、考前一天的正确打开方式</h3>
      <p>考前一天不建议高强度复习。整理好考试所需的物品（准考证、身份证、文具），提前踩点考场位置，晚上进行30分钟的轻松复习后，洗个热水澡，比平时早半小时上床。好的睡眠是考场发挥的基础。</p>
      
      <h3>三、考场上的即时减压技巧</h3>
      <p>如果在考场上突然紧张到大脑空白，试试「5-4-3-2-1」感官着陆法：找到5样你能看到的东西、4样你能触摸的东西、3样你能听到的声音、2样你能闻到的气味、1样你能尝到的味道。这个技巧能在30秒内帮你回到当下。</p>
    `,
    author: "第一次编辑部",
    authorAvatar: "",
    publishDate: "2026-08-01",
    readTime: "7分钟",
    imageSeq: "exam-anxiety-10",
    imageQuery: "A quiet peaceful study space with warm desk lamp lighting, open notebook and organized stationery, calming and focused atmosphere, soft cream and warm beige tones, editorial photography with serene mood, window showing early morning light, tidy bookshelf in background",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20quiet%20peaceful%20study%20space%20with%20warm%20desk%20lamp%20lighting%2C%20open%20notebook%20and%20organized%20stationery%2C%20calming%20and%20focused%20atmosphere%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20editorial%20photography%20with%20serene%20mood%2C%20window%20showing%20early%20morning%20light%2C%20tidy%20bookshelf%20in%20background&width=800&height=480&seq=exam-anxiety-10&orientation=landscape",
    tags: ["考试焦虑", "学习方法", "心理调节", "备考攻略"],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};